var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTwitter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9441 6.42638C17.9568 6.60403 17.9568 6.78173 17.9568 6.95938C17.9568 12.3781 13.8325 18.6218 6.29441 18.6218C3.97207 18.6218 1.81473 17.9492 0 16.7817C0.329961 16.8198 0.647187 16.8325 0.989844 16.8325C2.90605 16.8325 4.67004 16.1853 6.07867 15.0812C4.27664 15.0431 2.76648 13.8629 2.24617 12.2386C2.5 12.2766 2.75379 12.302 3.02031 12.302C3.38832 12.302 3.75637 12.2512 4.09898 12.1624C2.22082 11.7817 0.812148 10.132 0.812148 8.13958V8.08884C1.35781 8.39341 1.99238 8.58376 2.66492 8.60911C1.56086 7.87306 0.837539 6.61673 0.837539 5.1954C0.837539 4.43399 1.04055 3.73603 1.3959 3.12688C3.41367 5.61419 6.44668 7.23853 9.84766 7.41622C9.78422 7.11165 9.74613 6.79442 9.74613 6.47716C9.74613 4.21825 11.5736 2.37817 13.8451 2.37817C15.0253 2.37817 16.0913 2.8731 16.84 3.67259C17.7664 3.49493 18.6547 3.15228 19.4416 2.68274C19.137 3.63454 18.4898 4.43403 17.6395 4.94161C18.4644 4.85282 19.2639 4.62435 19.9999 4.30712C19.4416 5.11927 18.7436 5.84259 17.9441 6.42638Z",
    fill: "#0A0909"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.2b16b9af.svg";
export { ForwardRef as ReactComponent };